// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-class[data-v-d2f28048] {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  column-gap: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/ProjectClass/index.vue","webpack://./index.vue"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,aAAA;EACA,2BAAA;EACA,gBAAA;ACAF","sourcesContent":["\n.project-class {\n  height: 100%;\n  display: flex;\n  justify-content: flex-start;\n  column-gap: 12px;\n}\n",".project-class {\n  height: 100%;\n  display: flex;\n  justify-content: flex-start;\n  column-gap: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
